/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const camera_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M23 19.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h4.586a1 1 0 0 0 .707-.293l2.414-2.414a1 1 0 0 1 .707-.293h3.172a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 0 .707.293H22a1 1 0 0 1 1 1v12Z"
    />
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M15 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
)
export default camera_medium
